'use client';

import { Popover } from '@base-ui/react/popover';
import { css, cx } from '@repo/pandacss/styled-system/css';
import { type PropsWithChildren, useMemo } from 'react';
import { DisclosureTooltip, type DisclosureTooltipProps } from '../DisclosureTooltip';
import { advertisingDisclosureTooltipClassName } from '../disclosureTooltipPopover';
import { AdvertiserDisclosureText } from './AdvertiserDisclosureText';
import { AdvertisingDisclosureContent } from './AdvertisingDisclosureContent';

type AdvertisingDisclosureProps = PropsWithChildren<{
  buttonTextClassName?: string;
  placement?: DisclosureTooltipProps['placement'];
  tooltipClassName?: string;
  tooltipStyleOverrides?: React.CSSProperties;
  triggerClassName?: string;
}>;

const buttonTextStyles = css({
  backgroundColor: 'transparent',
  textStyle: 'textExtraSmall',
  color: 'blue.main',
  cursor: 'pointer',
  _hover: {
    textDecorationLine: 'underline',
  },
});

export function AdvertisingDisclosure({
  children,
  buttonTextClassName,
  placement,
  tooltipClassName,
  triggerClassName,
  tooltipStyleOverrides,
}: AdvertisingDisclosureProps) {
  const handler = useMemo(() => Popover.createHandle<unknown>(), []);
  return (
    <>
      <Popover.Trigger className={cx(buttonTextStyles, triggerClassName)} handle={handler}>
        {children ?? <AdvertiserDisclosureText className={buttonTextClassName} />}
      </Popover.Trigger>
      <DisclosureTooltip
        handler={handler}
        placement={placement}
        tooltipClassName={tooltipClassName ?? advertisingDisclosureTooltipClassName}
        tooltipStyleOverrides={tooltipStyleOverrides}
      >
        <AdvertisingDisclosureContent />
      </DisclosureTooltip>
    </>
  );
}
